import { StoreState } from "./index";

export const getMerchantId = (state: StoreState) => state.merchantId;
export const getCampaignId = (state: StoreState) => state.campaignId;
